import { partial } from '../../../util/translation/translation';
import {
  MIN_GAME_CHARGE,
  isAllowedAmount,
  isWholeKrPlan,
  minCapMultiplier,
  minPlanAmount,
} from '../amountRules';

const p = partial('validateErrors');
const validateTileForm = (values, { subscriptionPlan } = {}) => {
  const errors = {};
  // New plans and plans billed in whole kr take 0.1, 0.25 and 0.5; earlier
  // plans keep whole amounts
  const wholeKr = isWholeKrPlan(subscriptionPlan);
  const isAmount = (amount) =>
    wholeKr ? isAllowedAmount(amount) : Number.isInteger(amount);
  if (!values.name) {
    errors.name = p('nameFieldEmpty');
  }
  if (!values.description) {
    errors.description = p('descriptionFieldCantBeEmpty');
  }
  if (!values.subtitle) {
    errors.subtitle = p('subTitleFieldCantBeEmpty');
  }

  if (!values.endDate) {
    errors.endDate = p('endDateFieldCantBeEmpty');
  }
  if (
    values.showPriceMeter &&
    (!values.planDesiredValue ||
      Number.isNaN(values.planDesiredValue) ||
      Number(values.planDesiredValue) <= 0)
  ) {
    errors.planDesiredValue = p('planDesiredValueFieldCantBeEmpty');
  }
  const amountMin = Number(values.amountMin);
  // A quick option times the amount per score is the max per game: on whole
  // kr plans at least 5 kr at the lowest amount, as less isn't charged
  const minMultiplier =
    wholeKr && amountMin > 0 ? minCapMultiplier(amountMin) : 1;
  ['goal1', 'goal2', 'goal3'].forEach((fieldName) => {
    const multiplier = Number(values[fieldName]);
    if (!values[fieldName] || Number.isNaN(multiplier) || multiplier < 1) {
      errors[fieldName] = p('goalFieldCantBeEmpty');
    } else if (multiplier < minMultiplier) {
      errors[fieldName] = p('capOptionTooLow', {
        count: minMultiplier,
        min: MIN_GAME_CHARGE,
      });
    }
  });
  const popularAmounts = values.popularAmounts?.map(Number);
  if (
    !popularAmounts?.length ||
    popularAmounts.some((amount) => Number.isNaN(amount) || amount <= 0)
  ) {
    errors.popularAmounts = { _error: p('popularAmountsFieldCantBeEmpty') };
  } else if (
    popularAmounts.some(
      (amount) =>
        !isAmount(amount) || (wholeKr ? amount < amountMin : amount < 1)
    )
  ) {
    errors.popularAmounts = {
      _error: wholeKr ? p('popularAmountsNotAllowed') : p('wholeAmountOnly'),
    };
  }
  if (
    !values.amountStep ||
    Number.isNaN(values.amountStep) ||
    Number(values.amountStep) < 1
  ) {
    errors.amountStep = p('amountStepFieldCantBeEmpty');
  } else if (!Number.isInteger(Number(values.amountStep))) {
    errors.amountStep = p('wholeAmountOnly');
  }
  if (!values.amountMin || Number.isNaN(amountMin) || amountMin <= 0) {
    errors.amountMin = p('amountMinFieldCantBeEmpty');
  } else if (!isAmount(amountMin) || (!wholeKr && amountMin < 1)) {
    errors.amountMin = wholeKr ? p('amountNotAllowed') : p('wholeAmountOnly');
  } else if (
    wholeKr &&
    amountMin < minPlanAmount(values.scoreType?.value || values.scoreType)
  ) {
    errors.amountMin = p('amountMinTooLowForScoreType', {
      min: MIN_GAME_CHARGE,
    });
  }
  if (!values.scoreType) {
    errors.scoreType = p('scoreTypeFieldCantBeEmpty');
  }
  if (
    !values.goalCapPerGameStep ||
    Number.isNaN(values.goalCapPerGameStep) ||
    Number(values.goalCapPerGameStep) < 1
  ) {
    errors.goalCapPerGameStep = p('goalCapPerGameStepFieldCantBeEmpty');
  }
  return errors;
};
export default validateTileForm;
